import { config } from "@/config";
import { chatApiAxios } from "@/plugins";
import { HttpRequestMethodEnum } from "@/types/api";
import { IDeleteMessagesObject } from "@/types/chat";

export const deleteMessagesBeAsync = async ({
  messageIds,
  accessToken,
}: IDeleteMessagesObject) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  const res = await chatApiAxios(config.api.chatApi.endpoints.message.index, {
    method: HttpRequestMethodEnum.DELETE,
    headers,
    data: {
      messageIds,
    },
  });
  return res.data;
};
